import script from "./IntroductionImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionImage.vue?vue&type=script&setup=true&lang=ts"

import "./IntroductionImage.vue?vue&type=style&index=0&id=5aa6b69a&lang=scss"

const __exports__ = script;

export default __exports__